import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const StaleRetailers = () => {
  const theme = useTheme();

  const staleRetailers: { name: string, lastOrder: string }[] = [
  ];

  return (
    <List style={{ height: 200, color: theme.palette.text.primary, fontSize: theme.typography.textSM.fontSize }}>
      {staleRetailers.map((retailer, index) => (
        <ListItem key={index}>
          <ListItemText
            primary={retailer.name}
            secondary={`Last Order: ${retailer.lastOrder}`}
            primaryTypographyProps={{ style: { color: theme.palette.text.primary, fontSize: theme.typography.textSM.fontSize } }}
            secondaryTypographyProps={{ style: { color: theme.palette.text.secondary, fontSize: theme.typography.textXS.fontSize } }}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default StaleRetailers;